var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-card",
    { attrs: { flat: "" } },
    [
      _c(
        "v-card-text",
        [
          _c(
            "v-row",
            [
              _c("v-col", { attrs: { cols: "12" } }, [
                _c("table", { staticClass: "sites-table" }, [
                  _c("thead", [
                    _c("tr", [
                      _c("th", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "SiteComponents.InspectionHistory.TableHeader.ProjectID"
                            )
                          )
                        ),
                      ]),
                      _c("th", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "SiteComponents.InspectionHistory.TableHeader.InspectionID"
                            )
                          )
                        ),
                      ]),
                      _c("th", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "SiteComponents.InspectionHistory.TableHeader.TypeOfInspection"
                            )
                          )
                        ),
                      ]),
                      _c("th", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "SiteComponents.InspectionHistory.TableHeader.GradeOfInspection"
                            )
                          )
                        ),
                      ]),
                      _c("th", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "SiteComponents.InspectionHistory.TableHeader.InspectorName"
                            )
                          )
                        ),
                      ]),
                      _c("th", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "SiteComponents.InspectionHistory.TableHeader.InspectionReport"
                            )
                          )
                        ),
                      ]),
                      _c("th", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "SiteComponents.InspectionHistory.TableHeader.Actions"
                            )
                          )
                        ),
                      ]),
                    ]),
                  ]),
                  _c(
                    "tbody",
                    _vm._l(_vm.inspections, function (inspection) {
                      return _c("tr", { key: inspection.id }, [
                        _c("td", { staticClass: "width-100px" }, [
                          _vm._v(_vm._s(inspection.projectId)),
                        ]),
                        _c("td", { staticClass: "width-100px" }, [
                          _vm._v(_vm._s(inspection.id)),
                        ]),
                        _c("td", { staticClass: "width-100px" }, [
                          _vm._v(_vm._s(inspection.typeOfInspection)),
                        ]),
                        _c("td", { staticClass: "width-100px" }, [
                          _vm._v(_vm._s(inspection.gradeOfInspection)),
                        ]),
                        _c("td", { staticClass: "width-100px" }, [
                          _vm._v(_vm._s(inspection.inspectorId)),
                        ]),
                        _c(
                          "td",
                          { staticClass: "text-center" },
                          [
                            _c(
                              "base-btn",
                              {
                                attrs: {
                                  color: "primary",
                                  loading: _vm.isLoading,
                                  disabled: _vm.isLoading,
                                  small: "",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.loadAndRenderReport(
                                      inspection.id
                                    )
                                  },
                                },
                              },
                              [
                                _c("v-icon", { attrs: { left: "" } }, [
                                  _vm._v("mdi-eye"),
                                ]),
                                _vm._v(" View "),
                              ],
                              1
                            ),
                            _c(
                              "base-btn",
                              {
                                staticClass: "ml-2",
                                attrs: {
                                  color: "secondary",
                                  disabled: !_vm.hasReport || _vm.isLoading,
                                  small: "",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.downloadReport(inspection.id)
                                  },
                                },
                              },
                              [
                                _c("v-icon", { attrs: { left: "" } }, [
                                  _vm._v("mdi-download"),
                                ]),
                                _vm._v(" Download "),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "td",
                          {
                            staticClass: "width-200px text-center",
                            staticStyle: { "white-space": "nowrap" },
                          },
                          [
                            _c(
                              "div",
                              [
                                _c(
                                  "base-btn",
                                  {
                                    staticClass: "white--text mr-1 mb-1",
                                    attrs: { color: "blue", "x-small": "" },
                                  },
                                  [_vm._v(" Edit ")]
                                ),
                                _c(
                                  "v-btn",
                                  {
                                    staticStyle: {
                                      padding: "5px",
                                      "margin-left": "10px",
                                    },
                                    attrs: {
                                      color: "error",
                                      dark: "",
                                      "x-small": "",
                                    },
                                  },
                                  [_vm._v(" Delete ")]
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                      ])
                    }),
                    0
                  ),
                ]),
              ]),
            ],
            1
          ),
          _c("v-divider", { staticClass: "mt-5" }),
          _c("div", { staticClass: "report-content pa-4" }, [
            !_vm.hasReport && !_vm.isLoading && !_vm.errorMessage
              ? _c("div", { staticClass: "text-center text--secondary" }, [
                  _c("p", [
                    _vm._v(
                      'Report not available. Please click on "Generate & View" to generate a new report.'
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm.isLoading
              ? _c(
                  "div",
                  { staticClass: "text-center" },
                  [
                    _c("v-progress-circular", {
                      attrs: { indeterminate: "", color: "primary" },
                    }),
                    _c("p", { staticClass: "mt-4" }, [
                      _vm._v("Loading report preview..."),
                    ]),
                  ],
                  1
                )
              : _vm._e(),
            _vm.errorMessage
              ? _c(
                  "div",
                  { staticClass: "text-center red--text text--darken-2" },
                  [_c("p", [_vm._v(_vm._s(_vm.errorMessage))])]
                )
              : _vm._e(),
            _c("div", {
              ref: "reportContainer",
              staticClass: "docx-preview-wrapper",
            }),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }